import { environment } from '../../../environments/environment.stage';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ValidateExistenceService {
	constructor(private api: ApiService, private http: HttpClient) {}

	validateEmail(email: string): Observable<any> {
		return this.api.get(`/users/params/validation?_email=${email}`);
	}
	validateUsername(username: string): Observable<any> {
		return this.api.get(`/users/params/validation?_username=${username}`);
	}
	validatePhone(phone: string): Observable<any> {
		return this.api.get(`/users/params/validation?_phone=${phone}`);
	}
}
